export default "__VITE_ASSET__Cqh2hMS6__"